import * as React from "react"
import {useEffect} from "react"
import {CardSeeker} from "@ui-seeker/core";
import {Grid} from "@mui/material";

import {MatchersLoadingSkuBlock} from "../../@components";
import {useMatchersBrandSkus} from "../@hooks";
import MatchersSKUsOptionsFilters from "./Filters";
import ProductOption from "./ProductOption";
import MatcherSkuImageComparisonModal from "./ImageComparisonModal";


export default function MatchersSKUsOptions({ showOptions, targetIndex, targetImage, brandID, options=[], selected=null, setSelectedSKU, saveMapping }) {
	const {
		brandOptions, isLoading, lineID, searchText, handleChangeLine, handleChangeSearchText
	} = useMatchersBrandSkus(brandID, options.map(({skuID}) => skuID))

	useEffect(() => {
		handleChangeSearchText('')
	}, [targetIndex]);

	return <CardSeeker>
		<Grid container spacing={4}>
			<Grid item xs={12}>
				<MatchersSKUsOptionsFilters
					brandID={brandID}
					lineID={lineID}
					onChangeLine={handleChangeLine}
					searchText={searchText}
					onInputChange={handleChangeSearchText}
				/>
			</Grid>

			{ !!isLoading && <Grid item xs={12}>
				<MatchersLoadingSkuBlock />
			</Grid> }

			{!isLoading && <Grid item xs={12}>
				<Grid container spacing={4} maxHeight="70vh" sx={{ overflowY: "auto" }}>
					{ !isLoading && !searchText && options.filter(op => showOptions || op.skuID === selected).map((data, idx) => <ProductOption key={data.skuID}
							isIAOption
							skuID={data.skuID}
							isSelected={selected !== null && selected === data.skuID}
							data={data}
							targetImage={targetImage}
							setSelectedSKU={setSelectedSKU}
							brandOptionsIndex={idx}
						/>) }

					{ !isLoading && brandOptions.map((data, idx) => {
						const aiOptionData = options.find(op => op.skuID === data.skuID)

						return <ProductOption key={data.skuID}
								isIAOption={!!aiOptionData}
								skuID={data.skuID}
								isSelected={selected !== null && selected === data.skuID}
								data={{...data, AIDistance: aiOptionData?.AIDistance}}
								targetImage={targetImage}
								setSelectedSKU={setSelectedSKU}
								brandOptionsIndex={showOptions && !searchText ? idx + options.length : idx}
							/>
					}) }
				</Grid>
			</Grid>}
		</Grid>

		<MatcherSkuImageComparisonModal
			brandOptions={showOptions && !searchText ? [...options, ...(brandOptions ?? [])] : brandOptions}
			setSelectedSKU={setSelectedSKU}
			saveMapping={saveMapping}
		/>
	</CardSeeker>
}